import { IAPIResult } from "../Models/UtilityModels";
import { UserFieldsDefinitionModel, UserFieldModel } from "./UserDefinedFieldModels";

export class UserDefinedFields {

    // ----------------------------------------------------------- //
    // Update UDF's
    static SaveUDFFieldsAtServer = (formEl: JQuery<HTMLElement>, url: string, overrideEntityID?: number): Promise<boolean> => {
        return new Promise<boolean>((resolve, reject) => {
            let vals: Array<UserFieldModel> = [];
    
            formEl.find('[data-udfstr]').each(function (e) {
                let data: UserFieldModel = $(this).data('udfstr');
                let existingval = $(this).data('existingval');
                data.value = $(this).val().toString();

                // Check for checkbox
                if ($(this).attr('type') == 'checkbox') data.value = $(this).is(":checked") == true ? "true" : "false";
                if (overrideEntityID != null && isNaN(overrideEntityID) == false) data.entityID = overrideEntityID;

                if ((data.value == "" || data.value == "false") && existingval == "False") {
                    // do nothing, this stops empty values being pushed to the server and saved
                }
                else {
                    vals.push(data);
                }
            });

            let query = { data: vals };
            $.post(url, query,
                function (result: IAPIResult) {
                    try {
                        if (result.success == true) {
                            resolve(true);
                        }
                        else {
                            resolve(false);
                        }
                    }
                    catch (err) {
                        console.log(err);
                        resolve(false);
                    }
                }
            ).fail(function (xhr) {
                resolve(false);
            });
        });
    }

    static ValidateUDFs = (formEl: JQuery<HTMLElement>): boolean => {
        let isValid = true;

        let formDataArr = formEl.serializeArray();

        let defs: Array<UserFieldsDefinitionModel> = [];
        formDataArr.forEach(function (d) {
            if (d.name.startsWith('UserFieldsDefinitionList') == true) defs.push(JSON.parse(d.value));
        });

        formEl.find('[data-udfstr]').each(function (e) {
            if ($(this).is(":visible") == true) {
                let data: UserFieldModel = $(this).data('udfstr');
                data.value = $(this).val().toString();
                $(this).parent().find('[name="udfValidationMsg"]').html("");

                //let def = defs.find(d => d.ID == data.UserFieldDefinitionID);
                let def: UserFieldsDefinitionModel = $(this).data('udfdef');
                if (def != null) {
                    if (def.regExValidationExpression != null) {
                        let regex = new RegExp(def.regExValidationExpression);
                        if (regex.test(data.value) == false) {
                            isValid = false;
                            var msg = def.regExInvalidMessage == null ? "Please enter a valid value" : def.regExInvalidMessage;
                            $(this).parent().find('[name="udfValidationMsg"]').html(msg);
                        }
                    }
                }
            }
        });

        return isValid;
    }

    static ShowHideUDFs = (value: string, formEl: JQuery<HTMLElement>): void => {
        // This is important, show the tab first otherwise isVisible is always false
        formEl.find('[name="UDFAutoGeneratedTab"]').show();

        // Get all the UDF fields, check to see if they are allowed to be shown or not
        formEl.find('[data-conditionaludfvalues]').each(function () {
            var allowedValuesStr: string = $(this).data('conditionaludfvalues');
            // If there are not conditional values, then just show the UDF
            if (allowedValuesStr == null || allowedValuesStr == "") {
                $(this).show();
                $(this).attr('data-visible', 'true');
            }
            else {
                // If there are conditional values, check them and either show/hide
                let allowedValues = allowedValuesStr.toString().split(',');
                if (allowedValues.find(f => f == value)) {
                    $(this).show();
                    $(this).attr('data-visible', 'true');
                }
                else {
                    $(this).hide();
                    $(this).attr('data-visible', 'false');
                }
            }
        });

        // Hide any tabs that have no UDF elements showing in them also
        formEl.find('[name="UDFAutoGeneratedTab"]').each(function () {
            let visible: boolean;
            $(this).find('[data-visible]').each(function () {
                if ($(this).attr('data-visible') == 'true') visible = true;
            });
            if (visible == true) {
                $(this).show();
            }
            else {
                $(this).hide();
            }
        });
        
    }
}






